<template>
  <div class="room-doc-view-component" :class="{ 'Customer': isCounselor }">
    <div class="room-mirroring-template-wrapper"
         ref="templateWrapper"
    >
      <RoomMirroringPalette ref="palette"
                          :role="role"
                          @click="({ e, data }) => { setToolkit(data.toolkit, e) }"
      />
      <div class="w-full min-h-0 flex-1 flex">
        <RoomMirroringSidebar v-if="hasEmceeRole()" />
        <div class="iframe-wrapper" ref="iframeWrapper">
          <iframe
                  :width="iframe.width"
                  :height="iframe.height"
                  ref="view"
                  title="view"
                  @load="viewLoaded"
          />
        </div>
      </div>
      <RoomMirroringFooter @prev="setPage(mirroringCurrentPage - 1)"
                           @next="setPage(mirroringCurrentPage + 1)"
                           @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

import $ from 'jquery'
import html2canvas from "html2canvas";
import {throttle} from 'lodash';
import {Decoder, Reader, tools} from "ts-ebml";

import {RoomMirroring} from "@/core/api/room.mirroring.api";
import {gooroomeeMediaExtension} from "@/lib/gooroomee/webrtc/GooroomeeMediaExtension";

import RoomMirroringFooter from "@/components/Room/Mirroring/RoomMirroringFooter.vue";
import RoomMirroringPalette from "@/components/Room/Mirroring/RoomMirroringPalette.vue";
import RoomMirroringSidebar from '@/components/Room/Mirroring/RoomMirroringSidebar.vue';

import {Device} from "@/utils";

const RoomMirroringDrawsList = {}
const RoomMirroringEventList = {}
const RoomMirroringPageSignatureList = {}
const RoomMirroringTimerList = {}

export default {
  name: 'RoomMirroring',
  components: {
    RoomMirroringFooter,
    RoomMirroringPalette,
    RoomMirroringSidebar
  },
  props: {
    roomGroupId: { type: String },
  },
  data() {
    let data = {
      prevToolkit: null,
      toolkit: 'Pencil',
      tmp_page_no: 0,
      isModalDrawtool: true,
      colorList: [
        '#000000', '#FFFFFF', '#7F7F7F', '#C3C3C3', '#880015',
        '#B97A57', '#FF0000', '#FFAEC9', '#FF7F27', '#FFC90E',
        '#FFF200', '#EFE4B0', '#22B14C', '#B5E61D', '#6EFFB9',
        '#0000FF', '#99D9EA', '#3F48CC', '#7092BE', '#A349A4'
      ],
      color: '#000000',
      strokeWidthInp: 14,
      strokeWidth: 7,
      canvasToolLineWidth: {},
      tools: {
        colorEnableTools: ['LaserPointer', 'Pencil', 'Highlighter', 'Text',
          'Circle', 'Rectangle', 'Diamond', 'Pentagon', 'Star', 'Triangle', 'Line', 'TwoLines'],
        strokeWidthEnbaleTools: [
          'Pencil', 'Highlighter', 'Eraser',
          'Circle', 'Rectangle', 'Diamond', 'Pentagon', 'Star', 'Triangle', 'Line', 'TwoLines'
        ],
        figureTools: [
          'Circle', 'Rectangle', 'Diamond', 'Pentagon', 'Star', 'Triangle', 'Line', 'TwoLines'
        ]
      },
      textSizeList: [10, 30, 60],
      textSize: null,
      mirroringTotalPage: 5,
      mirroringCurrentPage: 1,
      useDrawing: true,
      iframe: {
        width: '360px',
        height: '740px'
      },
      currentRemainTime: null,
      record: {
        status: 'stop'
      },
      preventMobileScreen: {
      },
      role: {
        draw: true,
        scroll: true,
      }
    };
    return data;
  },

  watch: {
    'me.roomUserRole.draw': function (enable) {
      this.setPermission();
    },
    'me.roomGroupId': function (enable) {
      this.setPermission();
    },
    toolkit: function (toolkit, prevToolkit) {
      if (toolkit != prevToolkit) {
        this.prevToolkit = toolkit;
      }

      // toolkit = this.csCanvas.getToolkit(toolkit);
      // if (!toolkit || !toolkit.style) {
      //   return;
      // }
      //
      // if (toolkit.style.strokeStyle) {
      //   this.color = toolkit.style.strokeStyle;
      // }
      // if (toolkit.style.lineWidth) {
      //   this.strokeWidthInp = toolkit.type == 'Text'
      //                         ? this.canvasToolLineWidth.text
      //                         : toolkit.style.lineWidth;
      // }
    },
    color: function (c) {
      if (!this.csCanvas) {
        return c;
      }
      let toolkit = this.csCanvas.getCurrentToolkit();

      if (toolkit && this.tools.colorEnableTools.includes(toolkit.type)) {
        this.tools.colorEnableTools.forEach(t => {
          t = this.csCanvas.getToolkit(t);
          if (!t || !t.style.strokeStyle) {
            return;
          }
          t.style.strokeStyle = c;
        });
      }
      this.$refs.palette.selectedColor = c;
    },
    strokeWidth: function (strokeWidth) {
      let n = parseInt(strokeWidth);
      n = Math.max(n, 2);
      n = Math.min(n, 70);
      strokeWidth = '' + n;

      let toolkit = this.csCanvas.getCurrentToolkit();

      if (this.tools.colorEnableTools.includes(toolkit.type)) {
        this.tools.colorEnableTools.forEach(t => {
          t = this.csCanvas.getToolkit(t);
          if (t.type === 'Text') {
            return;
          }

          t.style.lineWidth = strokeWidth;
        });
      }
    },
    strokeWidthInp: function (strokeWidth) {
      let n = parseInt(strokeWidth);
      n = Math.max(n, 2);
      n = Math.min(n, 70);
      strokeWidth = '' + n;

      let toolkit = this.csCanvas.getCurrentToolkit();

      if (this.tools.colorEnableTools.includes(toolkit.type)) {
        this.tools.colorEnableTools.forEach(t => {
          t = this.csCanvas.getToolkit(t);
          if (t.type === 'Text') {
            return;
          }

          t.style.lineWidth = strokeWidth;
        });
      }
    },
    useDrawing(use){
      this.setUseDrawingCanvas(this.mirroringView.csCanvas, use);
    },
    'role.draw': function (status) {
      this.setUseDrawingCanvas(this.mirroringView.csCanvas, status);
    },
    'role.scroll': function (status) {
      this.mirroringView.contentDocument.body.style.overflow = status ? 'auto' : 'hidden';
    },
  },

  computed: {
    ...mapGetters('room', ['room', 'isRoomMode', 'isInRoomGroup']),
    ...mapGetters('roomGroup', ['isInRoomGroup', 'getRoomGroupName']),
    ...mapGetters('doc', ['getRoomDoc', 'getRoomDocFile', 'getRoomDocFilePage', 'isWhiteBoardFile']),
    ...mapGetters('user', ['me', 'isMe', 'isGuestUser', 'hasRoleFunction', 'hasEmceeRole', 'hasRoomGroupRole', 'roomUserList']),

    textItemStyle() {
      return (size) => {
        return {
          width: '100%',
          height: '100%',
          background: `url('${require('@/assets/roomType/lms/img/text_on.svg')}') no-repeat center / ${size + 20}% auto`
        }
      }
    },
    textItemClass() {
      return textSize => {
        return {
          'selected': textSize === this.textSize && this.toolkit === 'Text'
        }
      }
    },
    textItemImg() {
      const status = this.toolkit === 'Text' ? 'on' : 'off';
      return require(`@/assets/roomType/lms/img/text_${status}.svg`);
    },
    isCounselor() {
      return !this.isGuestUser();
    },
    mirroringView() {
      return this.$refs.view;
    },
    isRecoding() {
      return this.record.status === 'start';
    },
    canRecord() {
      // TODO: 자동 녹화 기능 임시 제거
      return false
      // return !this.isRecoding
      //   && this.isCounselor
      //   && this.roomUserList.length > 1;
    }
  },

  created() {
    // test
    window.$c = this;
    this._event = _Event()
    this._events = _Events()

    this.$roomApi.addEventListeners(this._event, this)
    this.useDrawing = this.isCounselor
  },

  mounted() {
    // this.initCanvas()

    this.setRandomColorList()

    this.setPage(1, false)

    this.resizeObserver = new ResizeObserver(entries => {
      if(this.csCanvas) this.csCanvas.redraw();
    });
    this.resizeObserver.observe(this.$el);

    if (!this.hasEmceeRole()) {
      this.resize(this.$refs.templateWrapper, this.$refs.iframeWrapper);
      this.sendCustomerInfo();
    }

    if(this.canRecord){
      this.$nextTick(() => {
        setTimeout(() => {
          if(this.canRecord){
            this.recordStart();
          }
        }, 1000);
      });
    }

    this.preventMobileScreenTurnOff();
  },

  destroyed() {
    this.removeResize(this.$refs.templateWrapper, this.$refs.view);
    this.$roomApi.removeEventListeners(this._event)
    this.resizeObserver.disconnect();
  },
  methods: {
    ...mapActions('roomGroup', [
      'finishLoadingGroup'
    ]),
    resize(observer, entries) {
      this[`resizeObserver_${observer}_${entries}`] = new ResizeObserver(() => {
        // this.onResize(observer, entries);

        this.sendMirroringViewResizeInfo()
      });
      this[`resizeObserver_${observer}_${entries}`].observe(observer);
    },
    sendMirroringViewResizeInfo() {
      this.resize_send_throttle = this.resize_send_throttle || throttle(() => {
        const layer = this.mirroringView.contentDocument?.querySelector('[data-content-wrapper]')
          || this.mirroringView.contentDocument?.body?.firstElementChild;
        if(!layer){
          return;
        }
        RoomMirroring.sendEvent({
          type: 'room_mirroring_resize',
          data: {
            width: this.mirroringView.clientWidth,
            height: this.mirroringView.clientHeight,
            contentWidth: layer.offsetWidth,
            contentHeight: layer.offsetHeight,
          }
        });
      }, 1000 / 5, {
        leading: true
      })
      this.resize_send_throttle();
    },
    removeResize(observer, entries) {
      if (this[`resizeObserver_${observer}_${entries}`]) {
        this[`resizeObserver_${observer}_${entries}`].unobserve(observer);
      }
    },
    setRandomColorList() {
      const letters = '0123456789ABCDEF'

      let color = '#'
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }

      this.color = color;
      this.colorList.unshift(color)
    },
    setPermission() {
      let hasRole;
      if (!this.roomGroupId || this.roomGroupId === 'default') {
        hasRole = this.me.roomUserRole.draw;
      } else {
        hasRole = this.hasRoomGroupRole({
          roomGroupId: this.roomGroupId
        });
      }
      this.csCanvas.setToolkit(hasRole ? 'Pencil' : 'Move');
    },

    setPage (page, sendEvent = true){
      if(page > this.mirroringTotalPage || page < 1) {
        console.warn('not exist page ', page);
        return;
      }
      this.clearPageTimer()
      this.mirroringCurrentPage = page
      const url = `/mirroringTemplate/pages/${page}.html`;
      const view = this.mirroringView;
      if(view.src == url){
        return;
      }

      if(!this.isCounselor){
        Object.assign(this.iframe, {
          width: '100%',
          height: '100%',
        });
      }
      view.src = url;

      // if(!this.isCounselor){
      //   view.addEventListener('load', e => {
      //     this.sendMirroringViewResizeInfo();
      //   }, {once: true});
      // }

      let data = {
        type: 'room_mirroring_setPage',
        pageNo: this.mirroringCurrentPage,
      }
      if(sendEvent) {
        RoomMirroring.sendEvent(data);
      }
    },
    viewLoaded (e){
      const view = e.target;
      if(!view?.src) return;

      this.createDrawingCanvas(view);
      this.createSignatureCanvas(view);

      if(!this.isCounselor){
        this.sendMirroringViewResizeInfo();
      }else{
        this.onResizeIframe(this.iframe);
      }

      const document = view.contentDocument;
      document.addEventListener('scroll', e => {
        if(document.documentElement._r_scroll_start > 0){
          if(document.documentElement._r_scroll_start > 1){
            delete document.documentElement._r_scroll_start;
          }
          return;
        }

        // send : scrollTop
        document.scroll_send_throttle = document.scroll_send_throttle || throttle(() => {
          RoomMirroring.sendEvent({
            type: 'room_mirroring_scroll',
            scrollLeft: e.target.documentElement.scrollLeft,
            scrollTop: e.target.documentElement.scrollTop
          })
        }, 1000 / 5, {
          leading: true
        });

        document.scroll_send_throttle();
      });
      ['click', 'change', 'input'].forEach(eventType => {
        document.addEventListener(eventType, e => {
          if(this.isCounselor) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }

          const el = e.target;

          // form input
          if(el.matches('input')){
            const selector = `input[type="${el.type}"]`;
            const idx = Array.prototype.findIndex.call(document.querySelectorAll(selector), element => {
              return element === el;
            });
            // send : selector, attrs[value, checked, ...]
            let data = {
              selector,
              targetIndex : idx,
              value: el['value'],
              checked: el['checked']
            }
            RoomMirroring.sendEvent({
              type: 'room_mirroring_input',
              inputData: JSON.stringify(data)
            })
          }
          else if(el.matches('[data-btn-movePage]')){
            const movePage = parseInt( el.getAttribute('data-btn-movePage') );
            this.setPage(this.mirroringCurrentPage + movePage);
          }
        });
      })

      this.setPageTimer()
    },
    setPageTimer() {
      if(this.mirroringCurrentPage === 1 || this.mirroringCurrentPage === this.mirroringTotalPage) return;

      let roomMirroringTimer = RoomMirroringTimerList[this.mirroringCurrentPage];
      if(!roomMirroringTimer) {
        roomMirroringTimer = RoomMirroringTimerList[this.mirroringCurrentPage] = {}
        roomMirroringTimer.pageNo = this.mirroringCurrentPage
      }

      roomMirroringTimer.remainTimeSecond = 10 // 10s
      roomMirroringTimer.timerInterval = setInterval(() => {
        if(roomMirroringTimer.remainTimeSecond < 0) {
          clearInterval(roomMirroringTimer.timerInterval)
          return;
        }

        let h = '' + Math.min(parseInt(roomMirroringTimer.remainTimeSecond / (60*60)), 999);
        let m = '' + parseInt(roomMirroringTimer.remainTimeSecond / 60 % 60);
        let s = '' + parseInt(roomMirroringTimer.remainTimeSecond % 60);
        this.currentRemainTime = roomMirroringTimer.timerStr =
          h.lpad(2, '0')
          + ':' + m.lpad(2, '0')
          + ':' + s.lpad(2, '0')

        roomMirroringTimer.remainTimeSecond--
      }, 1000)
    },
    clearPageTimer() {
      let roomMirroringTimer = RoomMirroringTimerList[this.mirroringCurrentPage];
      if(roomMirroringTimer && roomMirroringTimer.timerInterval) {
        clearInterval(roomMirroringTimer.timerInterval)
      }
      this.currentRemainTime = null
    },
    createDrawingCanvas (view){
      if(view.csCanvas){
        view.csCanvas.getBase()[0].remove();
        delete view.csCanvas;
      }

      let container = (() => {
        let body = view.contentDocument.body;
        let container = body.querySelector('[data-layer-drawing]');
        if(!container){
          container = document.createElement('div');
          Object.assign(container.style, {
            'position': 'absolute',
            'left': '0px',
            'top': '0px',
            'z-index': '99',
            width: body.offsetWidth+'px',
            // height: body.offsetHeight+'px',
            height: body.scrollHeight+'px',
          });
          body.append(container);
        }

        this.container = container;
        return container;
      })();
      this.csCanvas = view.csCanvas = new $(container).csCanvas({
        toolkit: 'Highlighter', //'Pencil',
        pointerPreview: false,
        useWheel: false,
        metrix: {
          autoRatio: false
        },
        toolkitStyle: {
          lineWidth: 10,
          strokeStyle: '#f28500',
          opacity: '0.3'
        },
        css: {
          background: '',
          // width: body.clientWidth+'px',
          // height: body.clientHeight+'px',
        },
      }).csCanvas('csCanvas');
      this.toolkit = this.useDrawing ? 'Highlighter' : '';

      if(!this.useDrawing) {
        this.setUseDrawingCanvas(this.csCanvas, false);
      }
      Object.assign(view.csCanvas.getToolkit('Pencil').style, {
        lineWidth: 1,
        strokeStyle: '#000'
      });
      Object.assign(view.csCanvas.getToolkit('Eraser').style, {
        lineWidth: 30
      });

      // events
      const csc = view.csCanvas;
      csc.on('drawstart', e => {
        if(e.toolkit.type !== 'LaserPointer') return;

        RoomMirroring.sendEvent({
          type: 'room_mirroring_draw',
          drawData: {
            toolkit: e.toolkit.type,
            drawType: 'drawstart',
            data: JSON.stringify({
              point: e.drawData.oriPoint,
              strokeStyle: e.toolkit.style.strokeStyle
            })
          }
        })
      });
      csc.on('drawing', e => {
        if(e.toolkit.type !== 'LaserPointer') return;

        csc._lp_send_throttle = csc._lp_send_throttle || throttle(
          e => {
            RoomMirroring.sendEvent({
              type: 'room_mirroring_draw',
              drawData: {
                drawType: 'drawing',
                data: JSON.stringify({
                  point: e.drawData.oriPoint,
                })
              }
            })
          },
          1000 / 5,
          {
            leading: false,
          });
        csc._lp_send_throttle(e);
      });
      csc.on('drawend', e => {
        RoomMirroring.sendEvent({
          type: 'room_mirroring_draw',
          drawData: {
            toolkit: e.toolkit.type,
            drawType: e.type,
            data: JSON.stringify({
              style: e.toolkit.style,
              point: e.drawData.oriPointList
            })
          }
        })
      })

      this.setUseDrawingCanvas(this.mirroringView.csCanvas, this.useDrawing)

      if(RoomMirroringDrawsList[this.mirroringCurrentPage] && RoomMirroringDrawsList[this.mirroringCurrentPage].length) {
        RoomMirroringDrawsList[this.mirroringCurrentPage].forEach(drawData => this.draw(drawData))
      }
      if(RoomMirroringEventList[this.mirroringCurrentPage] && RoomMirroringEventList[this.mirroringCurrentPage].length) {
        RoomMirroringEventList[this.mirroringCurrentPage].forEach(eventData => this.setMirroringEventData(eventData))
      }
    },
    createSignatureCanvas (view){
      view.sgCanvas = [];
      view.contentDocument.querySelectorAll('[data-signature]').forEach((el, idx) => {
        const sgCvs = $(el).csCanvas({
          toolkit: 'Pencil',
          useWheel: false,
          toolkitStyle: {
            lineWidth: 5,
            strokeStyle: '#000'
          },
        }).csCanvas('csCanvas');
        view.sgCanvas.push(sgCvs);

        let roomMirroringSignature = this.getCurrentSignature(idx)
        if(roomMirroringSignature && roomMirroringSignature.length) {
          roomMirroringSignature.forEach(drawData => sgCvs.getToolkit(drawData.toolkit).draw(drawData.points, drawData.styleStroke));
        }

        if(this.isCounselor) {
          this.setUseDrawingCanvas(sgCvs, false);
          return;
        }

        sgCvs.on('drawend', e => {
          RoomMirroring.sendEvent({
            type: 'room_mirroring_signature_draw',
            data: {
              signatureIdx: idx,
              drawData: {
                toolkit: e.toolkit.type,
                points: e.drawData.oriPointList,
                styleStroke: e.toolkit.style
              }
            }
          });

        })
          .on('clear', e => {
            // other().clearCanvas(false);
            RoomMirroring.sendEvent({
              type: 'room_mirroring_signature_clear',
              data: {
                signatureIdx: idx,
              }
            });
          });
        el.querySelector('[data-signature-clear]').addEventListener('click', e => {
          sgCvs.clearCanvas();
        })

      });
    },
    setDrawToolkit (toolkit){
      switch(toolkit){
        case 'Pencil':
          break;
        case 'Highlighter':
          break;
      }
      this.mirroringView.csCanvas.setToolkit(toolkit);
    },
    setToolkit(toolkit, e) {
      if (this.csCanvas.currentToolkit.type === toolkit) {
        this.useDrawing = !this.useDrawing;
        if (!this.useDrawing) {
          this.toolkit = '';
          return;
        }
      }

      switch (toolkit) {
        case 'Eraser': {
          if (e.ctrlKey) {
            this.csCanvas.clearCanvas();
            return;
          }

          this.csCanvas.toolkits.Eraser.cursor = `url(${require('@/assets/roomType/lms/img/cursor_eraser_blue.png')}), default`;
          break;
        }
        case 'Text': {
          const fontSize = e;
          const font = this.RoomDocCanvas.getCanvasToolLineWidth('text', fontSize);
          let textToolkit = this.csCanvas.toolkits.Text;
          textToolkit.style.font = font;
          textToolkit.setTextStyle();
          break;
        }
      }

      this.useDrawing = true;
      this.toolkit = toolkit;
      this.csCanvas.setToolkit(toolkit);
    },

    changeColor(color) {
      this.color = color;
    },

    clearCanvas() {
      this.csCanvas.clearCanvas();
    },

    drawingToolkitUrl(toolkit) {
      let obj = {
        'LaserPointer': {
          img: 'laser-pointer', title: '레이저 포인터'
        },
        'Pencil': {
          img: 'pen', title: '펜'
        },
        'Highlighter': {
          img: 'pen', title: '형광펜'
        },
        'Eraser': {
          img: 'Eraser', title: '지우개'
        },
      };

      // @/assets/roomType/lms/img/pen_off.svg
      let s = this.toolkit === toolkit ? 'on' : 'off'
      return require(`@/assets/roomType/lms/img/${obj[toolkit].img}_${s}.svg`);
    },

    zoom(z) {
      let zoom = this.csCanvas.zoom();
      this.csCanvas.zoom(zoom + z, 'center');
    },

    zoomFit() {
      this.csCanvas.zoomFit();
    },

    zoomOri() {
      this.csCanvas.zoomOri();
    },

    onSelectText(textSize) {
      this.textSize = textSize;
      this.setToolkit('Text', textSize);
    },
    setUseDrawingCanvas (csCanvas, use){
      if(!csCanvas) return;
      const baseEl = csCanvas.getBase()[0];
      const cvs = csCanvas.getTempCanvas();
      [baseEl, cvs].forEach(el => {
        el.style.pointerEvents = use ? 'auto' : 'none';
      });
    },
    draw(drawData, userId) {
      let csCanvas = this.mirroringView.csCanvas

      const toolkit = csCanvas.getToolkit(drawData.toolkit || 'LaserPointer')
      const drawType = drawData.drawType
      const data = typeof(drawData.data) === 'string' ? JSON.parse(drawData.data) : drawData.data

      if(toolkit.type === 'LaserPointer') {
        if(drawType === 'drawstart' || drawType === 'drawing') {
          toolkit.draw({
            id: userId,
            point: data.point,
            strokeStyle: data.strokeStyle
          });
        }else{
          toolkit.draw(userId, true);
        }
      }else{
        if(drawType === 'drawstart' || drawType === 'drawing') {
          toolkit.draw({
            // id: 'test',
            point: data.point,
            strokeStyle: data.strokeStyle
          })
        } else {
          toolkit.draw(data.point, data.style)
        }
        this.addDrawData(drawData)
      }
    },
    addDrawData(drawData){
      if(!drawData) return;
      const drawType = drawData.drawType
      const data = typeof(drawData.data) === 'string' ? JSON.parse(drawData.data) : drawData.data
      const notSaveDraw = data.toolkit === 'LaserPointer' || drawType === 'drawstart' || drawType === 'drawing'
      if(notSaveDraw) return;

      if(!RoomMirroringDrawsList[this.mirroringCurrentPage]) {
        RoomMirroringDrawsList[this.mirroringCurrentPage] = []
      }else{
        RoomMirroringDrawsList[this.mirroringCurrentPage] = [...new Set(RoomMirroringDrawsList[this.mirroringCurrentPage])]
        if(RoomMirroringDrawsList[this.mirroringCurrentPage].findIndex(v => v === drawData) > -1){
          return;
        }
      }
      RoomMirroringDrawsList[this.mirroringCurrentPage].push(drawData)
    },
    setScroll({scrollLeft, scrollTop}) {
      const html = this.mirroringView.contentDocument.documentElement

      if(html.scrollLeft !== scrollLeft || html.scrollTop !== scrollTop){
        html._r_scroll_start = 1;
        // doc.scroll({
        //     top,
        //     // behavior: 'smooth',
        // });
        $(html).stop().animate({
          scrollLeft,
          scrollTop
        }, 500, () => {
          html._r_scroll_start = 2;
        })
      }
    },
    addMirroringEventData(eventData) {
      if(!eventData) return;
      if(typeof(eventData) === 'string') {
        eventData = JSON.parse(eventData)
      }
      let roomMirroringEvent = RoomMirroringEventList[this.mirroringCurrentPage]
      if(!roomMirroringEvent) {
        roomMirroringEvent = RoomMirroringEventList[this.mirroringCurrentPage] = []
      }
      let idx = roomMirroringEvent.findIndex(e => e.selector === eventData.selector && e.targetIndex === eventData.targetIndex)
      // 중첩 이벤트는 삭제
      if(idx > -1) {
        // roomMirroringEvent.splice(idx, 1)
      }
      roomMirroringEvent.push(eventData)

    },
    setMirroringEventData(eventData, showSelected = false) {
      const document = this.mirroringView.contentDocument
      if(typeof(eventData) === 'string') {
        eventData = JSON.parse(eventData)
      }
      let {selector, targetIndex} = eventData
      const el = document.querySelectorAll(selector)[targetIndex]
      if(el) {
        el['value'] = eventData.value
        el['checked'] = eventData.checked
        const labels = el.labels
        if(showSelected && labels && labels.length) {
          const label = labels[0]
          label.classList.add('selected');
          setTimeout(()=> {
            label.classList.remove('selected');
          }, 500)
        }
      }
      this.addMirroringEventData(eventData)
    },
    getCurrentSignature(signatureIdx) {
      let roomMirroringSignatureList = RoomMirroringPageSignatureList[this.currentMirroringPage];
      if(!roomMirroringSignatureList) {
        roomMirroringSignatureList = RoomMirroringPageSignatureList[this.currentMirroringPage] = {};
      }
      let roomMirroringSignature = roomMirroringSignatureList[signatureIdx];
      if(!roomMirroringSignature) {
        roomMirroringSignature = roomMirroringSignatureList[signatureIdx] = [];
      }
      return roomMirroringSignature;
    },
    onResizeIframe({ width, height, contentWidth, contentHeight }) {
      Object.assign(this.iframe, {
        width: parseFloat(width)+'px',
        height: parseFloat(height)+'px',
        contentWidth: parseFloat(contentWidth)+'px',
        contentHeight: parseFloat(contentHeight)+'px'
      });

      // content layer
      Object.assign(this.mirroringView.contentDocument.body.style, {
        width: contentWidth + 'px',
        height: contentHeight + 'px'
      });
      const layer = this.mirroringView.contentDocument.querySelector('[data-content-wrapper]')
        || this.mirroringView.contentDocument.body.firstElementChild;
      if(!layer){
        return;
      }

      const ratioWidth = contentWidth / layer.offsetWidth;
      const ratioHeight = contentHeight / layer.offsetHeight;
      layer.style.transform = `scaleX(${ratioWidth}) scaleY(${ratioHeight})`;

      // resize canvas
      // let body = this.mirroringView.contentDocument.body;
      // let csCanvas = this.mirroringView.csCanvas;
      // Object.assign(csCanvas.getBase()[0].style, {
      //   width: body.offsetWidth+'px',
      //   height: body.scrollHeight+'px',
      // })
      // csCanvas.size(
      //     body.offsetWidth, body.offsetHeight
      // );
      // recreate
      this.createDrawingCanvas(this.mirroringView);
    },
    preventMobileScreenTurnOff (){
      if(!Device.isMobile()){
        return;
      }

      const data = this.preventMobileScreen;

      let cvs = data.cvs = data.cvs || (() => {
        let cvs = document.createElement('canvas');
        cvs.width = cvs.height = 1;
        // cvs.style.backgroundColor = 'transparent';
        cvs.getContext('2d').fillRect(0,0,cvs.width,cvs.height);
        // document.body.append(cvs);
        return cvs;
      })();

      const video = data.video = data.video || (() => {
        let video = document.createElement('video');
        video.muted = true;
        video.controls = true;
        video.setAttribute('playsinline', '');
        Object.assign(video.style, {
          pointerEvents: 'none',
          opacity: 0,
          position: 'absolute',
          right: '0px',
          bottom: '0px',
          zIndex: '-1',
          border: '0',
          width: '3px',
          height: '3px',
        });
        // test
        // Object.assign(video.style, {
        //     pointerEvents: 'auto',
        //     opacity: 1,
        //     zIndex: '999',
        //     border: '1',
        //     width: '300px',
        //     height: '200px',
        // });
        document.body.append(video);
        return video;
      })();
      video.srcObject = cvs.captureStream(1);
      video.play().catch(e => console.error(e));
    },

    // Record
    async recordStart (){
      this.record.status = 'start';
      const frame = 2;

      await this.drawRecordCanvas(1000/frame);

      const recordCanvas = this.record.recordCanvas = (() => {
        if(this.record.recordCanvas){
          this.record.recordCanvas.remove();
        }
        const cvs = document.createElement('canvas');
        Object.assign(cvs.style, {
          posotion: 'absolute',
          left: '-10000px',
          top: '-10000px',
          pointerEvents: 'none',
          opacity: 0
        });
        document.body.append(cvs);
        return cvs;
      })();

      const stream = this.record.recordStream = recordCanvas.captureStream(frame);
      (() => {
        let ctx = new AudioContext();
        let gainNode = ctx.createGain();
        let oscillator = ctx.createOscillator();
        oscillator.start();
        oscillator.connect(gainNode);
        let dst = gainNode.connect(ctx.createMediaStreamDestination());
        gainNode.gain.value = 0.0001
        stream.addTrack(dst.stream.getAudioTracks()[0]);
      })();

      const recordData = this.record.recordData = [];
      const audioTrack = stream.getAudioTracks()[0];
      const mediaRecorder = this.record.mediaRecorder = new MediaRecorder(stream, {
        mimeType: 'video/webm; codecs=vp8',
        // mimeType: 'video/webm; codecs=vp9',
        //audioBitsPerSecond: 128000,
        //videoBitsPerSecond: 2500000
        // videoBitsPerSecond: 1024*1024 * 2
      });
      mediaRecorder.addEventListener('dataavailable', e => {
        if(!e.data || e.data.size === 0) {
          return;
        }
        if(recordData.length === 0){
          recordData.startDate = Date.now();
        }
        recordData.duration = Date.now() - recordData.startDate;
        recordData.push(e.data);
        recordData.size = (recordData.size || 0) + e.data.size;

        let time = Date.now() - mediaRecorder._startDate.getTime();
        time = parseInt(time / 1000);
        console.log('# record duration : %ds, %dkb', time,
          recordData.size/1024);

        if(audioTrack.enabled && time % 10 == 0){
          audioTrack.enabled = false;
        }
      });
      mediaRecorder.addEventListener('stop', e => {
        console.log('# record stopped');
      });
      mediaRecorder.start(1000);
      mediaRecorder._startDate = new Date();
      console.log('# record started :', new Date());
    },
    async getViewCapture (){
      if(!gooroomeeMediaExtension.isChromeExtensionInstalled()){
        return this.getViewCaptureFromHtml();
      }

      const imgData = await gooroomeeMediaExtension.Screen.captureScreen({
        format: 'jpeg', quality: 80,
        // chrome 지원 안함
        // rect: (() => {
        //     let target = $c.$refs.view;
        //     let rect = target.getClientRects()[0];
        //     return {x, y, width, height} = rect;
        // })()
      });
      let img = new Image();
      img.src = imgData.dataUrl;
      return new Promise((resolve, reject) => {
        img.onload = () => {
          let rect = (() => {
            let rect = this.mirroringView.getClientRects()[0];
            const ratio = window.devicePixelRatio || 1;
            ['x','y','width','height'].forEach(attr => rect[attr] = rect[attr]*ratio);
            return {
              x: rect.x, y: rect.y,
              width: rect.width, height: rect.height
            };
          })();
          resolve({
            src: img,
            rect
          })
        }
      })
    },
    async getViewCaptureFromHtml (){
      let view = this.mirroringView;
      const captureEl = view.contentDocument.body;
      const src = await html2canvas(captureEl, {
        logging: false,
        scale: 1,
        scrollX: 0,
        scrollY: -view.ownerDocument.defaultView.scrollY,
        windowWidth: view.ownerDocument.documentElement.offsetWidth,
        windowHeight: view.ownerDocument.documentElement.offsetHeight,
        ignoreElements: element => {
          const tagName = element.tagName.toLowerCase();
          if(tagName === 'link'){
            const linkUrl = element.getAttribute('href');
            if(linkUrl && !linkUrl.startsWith('/')){
              const doc = element.ownerDocument;
              const base = doc._base_root = doc._base_root || (() => {
                let path = doc.location.pathname;
                if(path.endsWith('/')){
                  return path;
                }
                return path.substring(0, path.lastIndexOf('/')+1 )
              })();
              element.href = base + linkUrl;
            }
          }
          // else if(tagName === 'canvas'){
          //   if(element === this.mirroringView.csCanvas.getTempCanvas()){
          //     return true;
          //   }
          // }
        }
      });

      return {
        src,
        rect: {
          x: 0, y:0, width:src.width, height:src.height
        }
      };
    },
    async drawRecordCanvas (timer=1000/5){
      this.record.recTimer = setTimeout(() => {
        this.drawRecordCanvas(timer);
      }, timer);

      let view = this.mirroringView;
      if(view.contentDocument.readyState !== 'complete'){
        return;
      }

      const recCvs = this.record.recordCanvas;
      if(!recCvs) return;

      const captureData = await this.getViewCapture();
      const srcCvs = captureData.src;
      const rect = captureData.rect;

      recCvs.width = rect.width;
      recCvs.height = rect.height;
      // recCvs.height = view.clientHeight;

      // let srcHeight = recCvs.height;
      // // recCvs.height = srcHeight;

      const ctx = recCvs.getContext('2d');
      ctx.drawImage(srcCvs,
        // x, y, recCvs.width, srcHeight,
        rect.x, rect.y, rect.width, rect.height,
        0, 0, recCvs.width, recCvs.height,
      );
    },
    recordStop (){
      console.log('# record stop');
      this.record.status = 'stop';
      clearTimeout(this.record.recTimer);
      this.record.mediaRecorder.stop();
      this.record.recordStream.getTracks().forEach(t => t.stop());
    },
    recordFileDownload (){
      const recordData = this.record.recordData;
      const blob = new Blob(recordData, {
        type: 'video/webm'
      });

      const download = (blob) => {
        console.log('# download record file :', blob)
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.href = url;
        a.download = `grm-record-mirroring-${Date.now()}.webm`;
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }

      const fileReader = new FileReader();
      fileReader.onload = function(){
        const decoder = new Decoder();
        const reader = new Reader();
        const ebmlElms = decoder.decode(this.result);
        ebmlElms.forEach(element => {
          if(element.type === 'unknown'){
            return;
          }
          reader.read(element);
        });
        reader.stop();

        let duration = reader.duration;
        console.log('# parse duration :', duration, recordData.duration);
        if(duration === 0){
          // console.warn('# parse duration fail :', duration, recordData.duration);
          // if(recordData.duration){
          //   duration = recordData.duration;
          // }
          download(blob);
          return;
        }

        const refinedMetadataBuf = tools.makeMetadataSeekable(reader.metadatas, duration, reader.cues);
        const body = this.result.slice(reader.metadataSize);
        const newBlob = new Blob([refinedMetadataBuf, body], {
          type: 'video/webm'
        });
        download(newBlob);
      }
      fileReader.onerror = function(e){
        console.error(e);
        download(blob);
      }
      fileReader.readAsArrayBuffer(blob);
    },
    sendCustomerInfo() {
      RoomMirroring.sendEvent({
        type: 'room_mirroring_customer_info',
        data: {
          name: this.me.nickname,
          residentRegistrationNumber: '910909-1******',
          phone: '010-9999-0909',
          model: `<div>
            <p>${Device.deviceInfo().device.brand} ${Device.deviceInfo().device.model}</p>
            <p>${Device.deviceInfo().client.name} (${Device.deviceInfo().client.version})</p>
            <p>${Device.deviceInfo().os.name} (${Device.deviceInfo().os.version})</p>
          </div>`,
          screenWidth: window.screen.width,
          screenHeight: window.screen.height,
        }
      });
    },
    changeCustomerRole(data) {
      const { role } = data.customer;

      this.role = {
        ...this.role,
        ...role
      }
    },
    submit() {
      this.$alert({
        text: '전자청약을 제출하시겠습니까?',
        ok: () => {
          RoomMirroring.sendEvent({
            type: 'room_mirroring_submit',
          });
          this.setPage(1)
        }
      })
    }
  },
}

function  _Event() {
  return {
    room_mirroring_event: function (e) {
      let event = e && e.data
      let listener = this._events[event.type];

      event.userId = e.userId
      event.toUserId = e.userId

      if(!listener){
        return;
      }
      listener.call(this, event);
    },
    room_user_enter: function(e) {
      if(this.canRecord){
        this.recordStart();
      }
      if (!this.isCounselor) {
        if(!this.isGuestUser(e.data.roomUser.userId)){
          setTimeout(() => {
            this.sendMirroringViewResizeInfo();
          }, 500);
        }
      }
    },
    room_user_leave: function(e) {
      if(this.isRecoding && !this.canRecord){
        this.recordStop();
      }
    }
  }
}
function _Events() {
  return {
    room_mirroring_setPage: function(e) {
      if(this.isMe(e.userId)) return;
      this.setPage(e.pageNo, false)
    },
    room_mirroring_draw: function(e) {
      if(this.isMe(e.userId)) {
        this.addDrawData(e.drawData)
        return;
      }
      this.draw(e.drawData, e.userId)
    },
    room_mirroring_input: function(e) {
      if(this.isMe(e.userId)) {
        this.addMirroringEventData(e.inputData);
        return;
      }

      this.setMirroringEventData(e.inputData, true);
    },
    room_mirroring_scroll: function(e) {
      if(this.isMe(e.userId)) return;

      this.setScroll(e)
    },
    room_mirroring_signature_draw: function(e){
      const { signatureIdx, drawData } = e.data;

      let roomMirroringSignature = this.getCurrentSignature(signatureIdx);
      roomMirroringSignature.push(drawData)

      if(this.isMe(e.userId)) return

      const sgCanvas = this.mirroringView.sgCanvas[signatureIdx]
      sgCanvas.getToolkit(drawData.toolkit).draw(drawData.points, drawData.styleStroke);
    },
    room_mirroring_signature_clear: function(e) {
      const { signatureIdx } = e.data;

      let roomMirroringSignature = this.getCurrentSignature(signatureIdx);
      if(!roomMirroringSignature.length) {
        return;
      }

      roomMirroringSignature.length = 0;

      if(this.isMe(e.userId)) return;
      const sgCanvas = this.mirroringView.sgCanvas[signatureIdx]
      sgCanvas.clearCanvas(false);
    },
    room_mirroring_resize: function(e) {
      if (this.isMe(e.userId)) return;

      this.onResizeIframe(e.data);
    },
    room_mirroring_change_customer_role: function(e) {
      if (this.isMe(e.userId)) return;

      this.changeCustomerRole(e.data);
    },
    room_mirroring_submit: function(e) {
      this.$alert({
        text: '전자청약이 제출되었습니다.',
        onlyOk: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.room-doc-view-component {
  position: relative;
}

.room-doc-canvas-view {
  height: 100%;
}
.room-mirroring-template-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  z-index: 1;
}
.iframe-wrapper {
  min-width: 0;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: auto;
}
</style>